import ManagerRepository from 'coreClasses/ManagerRepository';
import {IEventData} from 'coreClasses/events/IEvents';
import ECommerceEventModel from './EcommerceEventModel';

/**
 * Represents ViewSizesEventModel
 */
export default class ViewSizesEventModel extends ECommerceEventModel {
	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);
	}
}
